
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6f7b45fc!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Table.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Table.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-6f7b45fc!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Table.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Table.vue
// module id = 560
// module chunks = 2